import { useMutation, UseMutationResult } from 'react-query'

import { useCommentAction } from './useCommentAction'

export function useUpdateComment(
  onSuccess?: (
    data: any,
    variables: any,
    context: unknown
  ) => void | Promise<unknown>,
  onError?: (
    error: unknown,
    variables: any,
    context: unknown
  ) => void | Promise<unknown>
): UseMutationResult<
  any,
  unknown,
  {
    id: number
    content?: string
    visible?: boolean
  },
  unknown
> {
  const commentClient = useCommentAction()

  return useMutation(comment => commentClient.updateComment(comment), {
    onSuccess,
    onError,
  })
}
